/**
 * Utility functions for platform detection in web environment
 */

export const isAndroid = (): boolean => {
  if (typeof navigator === 'undefined') return false
  return /Android/i.test(navigator.userAgent)
}

export const isIOS = (): boolean => {
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export const isMobile = (): boolean => {
  return isAndroid() || isIOS()
}

export const getPlatform = (): 'ios' | 'android' | 'desktop' => {
  if (isIOS()) return 'ios'
  if (isAndroid()) return 'android'
  return 'desktop'
}

/**
 * Check if the device supports Apple Wallet
 */
export const supportsAppleWallet = (): boolean => {
  return isIOS()
}

/**
 * Check if the device supports Google Wallet
 */
export const supportsGoogleWallet = (): boolean => {
  return isAndroid()
}

/**
 * Get the appropriate wallet type for the current platform
 */
export const getWalletType = (): 'apple' | 'google' | 'none' => {
  if (supportsAppleWallet()) return 'apple'
  if (supportsGoogleWallet()) return 'google'
  return 'none'
}
